import React, { useState } from 'react';
import { motion } from 'framer-motion';
import "./main.css";

const myprojects = [
  { 
    projectTitle: "React Project", 
    category: "react", 
    imgPath: "WhatsApp Image 2025-07-01 at 21.55.17_ca7204f5.jpg",
    githubLink: "https://github.com/ZienabAlaa",
    liveLink: "https://coffee-delta-teal.vercel.app/",
  },
  { 
    projectTitle: "React Project", 
    category: "react", 
    imgPath: "WhatsApp Image 2025-08-11 at 00.11.46_bb9a0cfb.jpg",
    githubLink: "https://github.com/ZienabAlaa",
    liveLink: "https://portfolio-two-eta-5jgddd8ebs.vercel.app/"
  },

  { 
    projectTitle: "CSS & HTML Project", 
    category: "css", 
    imgPath: "IMG-20250711-WA0124.jpg",
    githubLink: "https://github.com/ZienabAlaa",
    liveLink: "https://destiny-psi.vercel.app/"
  },
 
   { 
    projectTitle: "CSS & HTML Project", 
    category: "css", 
    imgPath: "WhatsApp Image 2025-07-20 at 23.24.12_2a993f3d.jpg",
    githubLink: "https://github.com/ZienabAlaa",
    liveLink: "https://validation-form-pearl.vercel.app/"
  },
 
  { 
    projectTitle: "JavaScript Project", 
    category: "javascript", 
    imgPath: "IMG-20250711-WA0127.jpg",
    githubLink: "https://github.com/ZienabAlaa",
    liveLink:"https://responsive-watch-website.vercel.app/"
  },
  { 
    projectTitle: "JavaScript Project", 
    category: "javascript", 
    imgPath: "IMG-20250711-WA0128.jpg",
    githubLink: "https://github.com/ZienabAlaa",
    liveLink:"https://ecommerce-zeta-opal.vercel.app/"
  },
  { 
    projectTitle: "JavaScript Project", 
    category: "javascript", 
    imgPath: "IMG-20250711-WA0131.jpg",
    githubLink: "https://github.com/ZienabAlaa",
    liveLink:"https://data-seven-xi.vercel.app/"
  },
  { 
    projectTitle: "JavaScript Project", 
    category: "javascript", 
    imgPath: "IMG-20250711-WA0132.jpg",
    githubLink: "https://github.com/ZienabAlaa",
    liveLink:"https://responsive-ice-cream-shop.vercel.app/"
  },
  { 
    projectTitle: "JavaScript Project", 
    category: "javascript", 
    imgPath: "IMG-20250711-WA0133.jpg",
    githubLink: "https://github.com/ZienabAlaa",
    liveLink:"https://responsive-hospital.vercel.app/"
  },
  { 
    projectTitle: "JavaScript Project", 
    category: "javascript", 
    imgPath: "IMG-20250711-WA0129.jpg",
    githubLink: "https://github.com/ZienabAlaa",
    liveLink:"https://insure-kohl.vercel.app/"
  },
];

const Main = () => {
  const [currentActive, setCurrentActive] = useState("all");
  const [arr, setArr] = useState(myprojects);

  const filterProjects = (category) => {
    setCurrentActive(category);
    if (category === "all") {
      setArr(myprojects);
    } else {
      setArr(myprojects.filter(item => item.category === category));
    }
  };

  return (
    <main className="flex">
      <section className="flex left-section">
        {["all", "css", "javascript", "react"].map(category => (
          <button
            key={category}
            onClick={() => filterProjects(category)}
            className={currentActive === category ? "active" : ""}
            aria-pressed={currentActive === category}
          >
            {category === "all" && "All Projects"}
            {category === "css" && "HTML & CSS"}
            {category === "javascript" && "JavaScript"}
            {category === "react" && "React JS"}
          </button>
        ))}
      </section>

      <section className="flex right-section">
        {arr.length === 0 ? (
          <p style={{ color: "#888", fontSize: "1.2rem" }}>
            No projects found in this category.
          </p>
        ) : (
          arr.map((item, index) => (
            <motion.article
              key={`${item.projectTitle}-${index}`}
              className="card"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <img
                width={260}
                src={item.imgPath}
                alt={`${item.projectTitle} screenshot`}
                loading="lazy"
              />
              <div style={{ width: "260px" }} className="box">
                <h1 className="title">{item.projectTitle}</h1>
                <p className="sub-title">
                  This is a short project description. You can update it later with real content.
                </p>
                <div className="flex icons">
                  <div className="flex" style={{ gap: "11px" }}>
                    {item.liveLink && (
                      <a 
                        href={item.liveLink} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title="Live Demo" 
                        aria-label="Live Demo"
                      >
                        <div className="fa fa-link"></div>
                      </a>
                    )}
                    {item.githubLink && (
                      <a 
                        href={item.githubLink} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title="GitHub" 
                        aria-label="GitHub"
                      >
                        <div className="fa fa-github"></div>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </motion.article>
          ))
        )}
      </section>
    </main>
  );
};

export default Main;
